import PropTypes from 'prop-types';

export const nullable = propType => (props, propName, ...rest) =>
  props[propName] === null ? null : propType(props, propName, ...rest);

export const currencyPropType = PropTypes.string;
export const countryPropType = PropTypes.string;
export const moneyPropType = PropTypes.shape({
  amount: PropTypes.number.isRequired,
  currency: currencyPropType.isRequired
});

export const uiComponentSpecPropType = PropTypes.shape({
  key: PropTypes.string.isRequired,
  componentType: PropTypes.string.isRequired,
  componentProps: PropTypes.shape({})
});

export const uiSpecPropType = PropTypes.shape({
  version: PropTypes.number.isRequired,
  componentSequenceFixedHead: PropTypes.arrayOf(uiComponentSpecPropType).isRequired,
  componentSequenceLazyTail: PropTypes.arrayOf(uiComponentSpecPropType).isRequired
});

export const billablePropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  full_unit_price: moneyPropType.isRequired,
  full_total_price: moneyPropType.isRequired,
  total_price: moneyPropType.isRequired,
  unit_price: moneyPropType.isRequired,
  quantity: PropTypes.number.isRequired,
  details: PropTypes.arrayOf(PropTypes.string).isRequired,
  canceled: PropTypes.bool.isRequired
});

export const invoicePropType = PropTypes.shape({
  order_id: PropTypes.number.isRequired,
  date_created_utc: PropTypes.string.isRequired,
  to_who: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  address_id: PropTypes.number.isRequired,
  billables: PropTypes.arrayOf(billablePropType).isRequired,
  grand_total: moneyPropType.isRequired
});

export const invoicePaymentPropType = PropTypes.shape({
  order_id: PropTypes.number.isRequired,
  from_who: PropTypes.string.isRequired,
  date_created: PropTypes.string.isRequired,
  money: moneyPropType.isRequired,
  payment_method: PropTypes.number.isRequired,
  exchange_rate_to_settlement: PropTypes.number.isRequired,
  optional_stripe_payment_intent_id: nullable(PropTypes.string.isRequired)
});
